import Cookies from "js-cookie";

// The cookie domain is derived at RUNTIME from the current host, so the one
// static build works on every domain it is served from. channels.social keeps
// the exact same `.channels.social` cookie as before; channelssocial.com gets
// `.channelssocial.com`. Unknown hosts (localhost, IPs, embeds) fall back to a
// host-only cookie — browsers reject a `.domain` that doesn't match the host,
// which would silently break login.
const KNOWN_COOKIE_DOMAINS = [".channels.social", ".channelssocial.com"];

const getCookieDomain = () => {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname;
  const match = KNOWN_COOKIE_DOMAINS.find(
    (d) => host === d.slice(1) || host.endsWith(d),
  );
  return match || null;
};

// Derive cookie options from the current host at runtime. Known prod domains get
// the shared `.domain` cookie; unknown hosts (localhost, IPs, embeds) fall back to
// a host-only cookie — exactly what we want locally, since browsers reject a
// `.localhost` / ported domain and login wouldn't persist otherwise.
const getCookieOptions = () => {
  const domain = getCookieDomain();
  return domain ? { domain, path: "/" } : { path: "/" };
};

export const setAuthCookies = (token, user) => {
  const userData = {
    name: user.name,
    username: user.username,
    _id: user._id,
  };

  const cookieOptions = getCookieOptions();

  Cookies.set("token", token, cookieOptions);
  Cookies.set("user", JSON.stringify(userData), cookieOptions);

  const expiryTime = new Date().getTime() + 14 * 24 * 60 * 60 * 1000;
  Cookies.set("tokenExpiry", expiryTime, cookieOptions);
};

export const getAuthToken = () => Cookies.get("token");

export const getUserData = () => {
  const user = Cookies.get("user");
  return user ? JSON.parse(user) : null;
};

export const checkTokenExpiry = () => {
  const tokenExpiry = Cookies.get("tokenExpiry");
  if (tokenExpiry && new Date().getTime() > tokenExpiry) {
    removeAuthCookies();
    return true;
  } else {
    return false;
  }
};

export const removeAuthCookies = () => {
  const cookieOptions = getCookieOptions();

  Cookies.remove("token", cookieOptions);
  Cookies.remove("user", cookieOptions);
  Cookies.remove("tokenExpiry", cookieOptions);
};

export const updateAuthUsername = (newUsername) => {
  const user = getUserData();
  if (user) {
    user.username = newUsername;
    Cookies.set("user", JSON.stringify(user), getCookieOptions());
  }
};

/*import Cookies from "js-cookie";
import { domainUrl } from "./../utils/globals";
export const setAuthCookies = (token, user) => {
  const userData = {
    name: user.name,
    username: user.username,
    _id: user._id,
  };
  Cookies.set("token", token);
  Cookies.set("user", JSON.stringify(userData));
  const expiryTime = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
  Cookies.set("tokenExpiry", expiryTime);
};
export const getAuthToken = () => Cookies.get("token");
export const getUserData = () => {
  const user = Cookies.get("user");
  return user ? JSON.parse(user) : null;
};
export const checkTokenExpiry = () => {
  const tokenExpiry = Cookies.get("tokenExpiry");
  if (tokenExpiry && new Date().getTime() > tokenExpiry) {
    removeAuthCookies();
    return true;
  } else {
    return false;
  }
};
export const removeAuthCookies = () => {
  Cookies.remove("token");
  Cookies.remove("user");
  const allCookies = Cookies.get();
  Object.keys(allCookies).forEach((cookieName) => {
    Cookies.remove(cookieName, { path: "/" });
    Cookies.remove(cookieName, { path: "/", domain: `.${domainUrl}` });
  });
};
export const updateAuthUsername = (newUsername) => {
  const user = getUserData();
  if (user) {
    user.username = newUsername;
    Cookies.set("user", JSON.stringify(user));
  }
};*/
